import { render, staticRenderFns } from "./OrdersOverview.vue?vue&type=template&id=2f2182fa&scoped=true"
import script from "./OrdersOverview.vue?vue&type=script&lang=js"
export * from "./OrdersOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2182fa",
  null
  
)

export default component.exports